import React from 'react';
import { ComplementaryInfoContainer } from '../../ticketForm/components/ComplementaryInfoContainer';
import PremiumSection from '../../ticketForm/components/PremiumSection';
import { QuoteComplementaryInfoSection } from '../sections/QuoteComplementaryInfoSection';

export const QuoteFormComplementaryInputsBlock = ({ quoteFormBodyData }) => {
  return (
    <ComplementaryInfoContainer>
      <PremiumSection>
        <QuoteComplementaryInfoSection quoteFormBodyData={quoteFormBodyData} />
      </PremiumSection>
    </ComplementaryInfoContainer>
  );
};
